const useManageStock = (maxQty, orderCount, quantity) => {
  const availableStock = maxQty !== undefined ? maxQty - (orderCount || 0) : Infinity
  const remainingStock = availableStock - quantity
  const isSoldOut = availableStock <= 0

  return {
    availableStock,
    remainingStock,
    isSoldOut,
  }
}

export default useManageStock
